import { gql } from "lib/apolloClient";

export const behaviourConfigurationFragment = {
  actionDetailsFragment: gql`
    fragment actionDetails on BehaviourAction {
      id
      title
      type
      state
      metadata
      sentiments {
        id
        label
      }
      accessibilityMap {
        id
        entityId
        type
      }
    }
  `,
};

export const behaviourCategoryFragment = gql`
  fragment behaviourCategoryFragment on BehaviourCategory {
    id
    name
    color
    sentiment {
      id
      label
    }
    associatedIncidentsCount(filters: $filters)
    status
    curriculumPrograms {
      id
      label
      acronym
    }
  }
`;
